'use client';

import {
  type ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';

import { type HostClientType, app } from '@microsoft/teams-js';

type TeamsContextState = {
  isInTeams: boolean;
  isInitialized: boolean;
  hostClientType?: HostClientType;
};

const TeamsContext = createContext<TeamsContextState>({
  isInTeams: false,
  isInitialized: false,
});

export const useTeamsContext = () => useContext(TeamsContext);

export const TeamsContextProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<TeamsContextState>({
    isInTeams: false,
    isInitialized: false,
  });

  useEffect(() => {
    const init = async () => {
      /* eslint-disable-next-line functional/no-try-statement */
      try {
        await app.initialize();
        const context = await app.getContext();
        setState({
          isInTeams: true,
          isInitialized: true,
          hostClientType: context.app.host.clientType,
        });
      } catch (err) {
        setState({ isInTeams: false, isInitialized: true });
      }
    };

    void init();
  }, []);

  return (
    <TeamsContext.Provider value={state}>{children}</TeamsContext.Provider>
  );
};
